import {Box, Button, Dialog, DialogActions, Typography} from '@mui/material';
import PropTypes from 'prop-types';
import React, {useEffect, useState} from 'react';
import DialogContent from '@mui/material/DialogContent';
import {FileUploadComponent} from '../shared/FileUploadComponent.jsx';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import {RFDocument, applyDownload} from './Utils';
import {Cached, Download} from '@mui/icons-material';

/**
 * @param {boolean} open
 * @param {Object} document
 * @param {function(File)} handleClose
 * @return {JSX.Element}
 */
export function BCPDataGridDocumentDialog({open, document, handleClose}) {
    const [uploadedFile, setUploadedFile] = useState(null);
    const [uploadNewFile, setUploadNewFile] = useState();
    const [rfDocument, setRFDocument] = useState(null);
    const [dataUrl, setDataUrl] = useState('');

    // when opening the popup:
    //  * check if a remote document exists for the edited row
    //     -> and create a cache to download the document if not done so already
    //  * reset the fileUploadComponent
    useEffect(() => {
        if(open) {
            if(document !== null && (rfDocument === null || rfDocument.fileID !== document.fileID)) {
                const doc = new RFDocument(document);
                setRFDocument(doc);
                setDataUrl('');
                doc.fetchDataUrl().then(setDataUrl);
            }
            setUploadNewFile(document === null);
            setUploadedFile(null);
        }
    }, [open]);

    const handleReplace = () => {
        setUploadNewFile(true);
    };

    let content, actions;
    if(uploadNewFile === true) {
        content = <>
            <Typography className='datagrid-dialog-title'><b>Document</b></Typography>
            <FileUploadComponent
                file={uploadedFile} setFile={setUploadedFile}
                style={{width: '300px', height: '150px'}}
            />
        </>;
        if(uploadedFile !== undefined) {
            actions = <div className='popup-save-button-container'>
                <Button
                    className='popup-save-button'
                    variant='contained'
                    onClick={() => { handleClose(uploadedFile); }}
                >Save</Button>
            </div>;
        }
    } else if(uploadNewFile === false) {
        content = <>
            <Box className="remoteFileComponent-header">
                <p style={{ color: '#F19100', textOverflow: 'ellipsis', overflow: 'hidden', minWidth: "300px", fontSize: "20px", flexGrow: 1 }}>
                    {rfDocument?.getFullName()}
                </p>
                <Button
                    className={'popup-save-button'}
                    style={{ marginLeft: "10px", marginRight: "10px", flexGrow: 0 }}
                    variant='contained'
                    onClick={handleReplace}
                >
                    <Cached />&nbsp;&nbsp;&nbsp;
                    Replace document
                </Button>
                <IconButton
                    onClick={async () => { applyDownload(dataUrl, rfDocument?.getFullName()); }}
                    disabled={dataUrl === null}
                    style={{flexGrow: 0}}
                >
                    <Download sx={{fontSize: "2rem !important"}} />
                </IconButton>
            </Box>
            <Box className="remoteFileComponent-browserViewContainer">
                <object data={dataUrl} type={rfDocument?.getMimeType()}
                        className="remoteFileComponent-browserView"
                        ref={(el) => {
                            if(el) {
                                // force to take all space available in parent (using 100% does not work)
                                el.width = el.parentElement.clientWidth+"px";
                                el.height = (el.parentElement.clientWidth*3/4)+"px";
                            }
                        }}
                >
                    <Typography align='center' sx={{width: "100%"}}>
                        This document cannot be displayed in browser. Please download it.
                    </Typography>
                </object>
            </Box>
        </>;
    }

    return <Dialog
            onClose={handleClose}
            open={open}
            // make popup with extra large width only when viewing document
            fullWidth={uploadNewFile === false}
            maxWidth={'xl'}
    >
            <DialogTitle className='datagrid-dialog-closeIconContainer'>
                <IconButton onClick={handleClose}>
                    <CloseIcon fontSize='large' />
                </IconButton>
            </DialogTitle>
            <DialogContent>
                {content}
            </DialogContent>
            <DialogActions>
                {actions}
            </DialogActions>
    </Dialog>;
}

BCPDataGridDocumentDialog.propTypes = {
    open: PropTypes.bool,
    document: PropTypes.object,
    handleClose: PropTypes.func,
};

